import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 12"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12 1c0-.6-.4-1-1-1s-1 .4-1 1v7.6L1.7.3C1.3-.1.7-.1.3.3s-.4 1 0 1.4L8.6 10H1c-.6 0-1 .4-1 1s.4 1 1 1h10c.1 0 .3 0 .4-.1.2-.1.4-.3.5-.5.1-.1.1-.3.1-.4z"
    }, null, -1)
  ]))]))
}
export default { render: render }